import { Sparkles } from 'lucide-react';
import { useSearchLimits } from '../../hooks/useSearchLimits';

export function OutOfSearchesWall() {
  const { usage } = useSearchLimits();
  const limit = usage?.limit ?? 30;

  return (
    <div className="panel mx-auto max-w-xl space-y-4 p-10 text-center">
      <div className="mx-auto inline-flex rounded-2xl border border-primary/25 bg-primary/10 p-4 text-primary">
        <Sparkles className="h-8 w-8" />
      </div>
      <h2 className="display text-2xl font-semibold">You're out of recommendation pulls this month</h2>
      <p className="leading-relaxed text-muted-foreground">
        You've used all {limit} pulls this month. Premium (coming soon) will unlock more.
        Your pulls reset at the start of next month (UTC).
      </p>
    </div>
  );
}
